import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface SearchOrderList {
  id: number
  selectionDate: string
  selectionCount: number
  selectionType: SystemCode
  isCompleted: boolean
  displayMemo: string
  selectionNumber: number
  orderNumber: number
  editingSystemUserId: number
  revision: number
}

export function SearchOrderListFromJSON(json: any): SearchOrderList {
  return {
    id: exists(json, 'id') ? json.id : 0,
    selectionDate: exists(json, 'selection_date')
      ? dateToPlainFormat(json.selection_date)
      : '',
    selectionCount: exists(json, 'selection_count') ? json.selection_count : 0,
    selectionType: exists(json, 'selection_type')
      ? SystemCodeFromJSON(json.selection_type)
      : defaultSystemCode(),
    isCompleted: exists(json, 'is_completed') ? json.is_completed : false,
    displayMemo: exists(json, 'display_memo') ? json.display_memo : '',
    selectionNumber: exists(json, 'selection_number')
      ? json.selection_number
      : 0,
    orderNumber: exists(json, 'order_number') ? json.order_number : 0,
    editingSystemUserId: exists(json, 'editing_system_user_id')
      ? json.editing_system_user_id
      : 0,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}

export const OrderListStatus = {
  Processing: '1',
  Complete: '2',
  All: '3'
}
export type OrderListStatus = typeof OrderListStatus[keyof typeof OrderListStatus]
